import React, { Component } from 'react'

// This component will catch any errors in any of its children
class ErrorBoundary extends Component {
  constructor(props) {
    super(props)

    this.state = {
      hasError: false,
    }
  }

  componentDidCatch(error, info) {
    //console.error(error)
    console.log(info)
    this.setState({ hasError: true })
  }

  // TODO: maybe pass a prop for each component, either `important` or not, and if the module is like, important for the user, we should render some error UI, if its not important, (like some extra tray) we can just render nothing?
  render() {
    return this.state.hasError ? <div /> : this.props.children
  }
}

export default ErrorBoundary;
